import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { pickHTMLProps } from 'pick-react-known-prop';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      position: 'fixed',
      zIndex: theme.zIndex.appBar,
      top: 0,
      left: 0,
      right: 0,
      paddingBottom: theme.spacing(2),
      background: theme.palette.common.white,
      boxShadow: theme.shadows[6]
    },
    appbar: _defineProperty({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }),
    appmenu: {},
    logo: {
      marginRight: 'auto'
    }
  };
}, {
  name: 'SxAppWebHeaderWide'
});
var AppWebHeaderWide = React.forwardRef(function (_ref, ref) {
  var AppBarWide = _ref.appBarActions,
      AppMenu = _ref.appMenu,
      pClasses = _ref.classes,
      className = _ref.className,
      Logo = _ref.logo,
      maxWidth = _ref.maxWidth,
      rest = _objectWithoutProperties(_ref, ["appBarActions", "appMenu", "classes", "className", "logo", "maxWidth"]);

  var classes = useStyles({
    classes: pClasses
  });
  return React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className),
    ref: ref
  }), React.createElement(Container, {
    maxWidth: maxWidth,
    className: classes.appbar
  }, React.createElement(Logo, {
    className: classes.logo
  }), React.createElement(AppBarWide, null)), React.createElement(Container, {
    maxWidth: maxWidth,
    className: classes.appmenu
  }, React.createElement(AppMenu, null)));
});
AppWebHeaderWide.propTypes = {
  appBarActions: PropTypes.elementType,
  appMenu: PropTypes.elementType,
  classes: PropTypes.shape({
    appbar: PropTypes.string,
    appmenu: PropTypes.string,
    logo: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  logo: PropTypes.elementType,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false])
};
AppWebHeaderWide.defaultProps = {
  appBarActions: undefined,
  appMenu: undefined,
  classes: undefined,
  className: undefined,
  logo: undefined,
  maxWidth: false
};
export default AppWebHeaderWide;